import { Type } from 'class-transformer';
import { isFuture } from 'date-fns';
import { Nullable } from '@cast/leadcast-types';
import { Contract } from './Contract';
import { Material } from './inventory/Material';
import { PropertyDetails } from './inventory/PropertyDetails';
import { ServiceLineMaterial } from './ServiceLineMaterial';
import { CustomProperties } from './inventory/CustomProperties';
import { ServiceLineType } from './ServiceLineType';

export interface ServiceLine {
  id: string;
  externalId: string;
  side: ServiceLineSide;
  installationDate: Nullable<string>;
  serviceLineMaterials: ServiceLineMaterial[];
  sharedProperties: Pick<PropertyDetails, 'id' | 'externalId' | 'address' | 'addressUnit'>[];
  serviceLineType: ServiceLineType;
  diameter: Nullable<number>;
  waterMainDiameter: Nullable<number>;
  tapSize: Nullable<number>;
  length: Nullable<number>;
  isPreviouslyLead: Nullable<boolean>;
  previousLeadSource: Nullable<string>;
  containsLeadSolder: Nullable<boolean>;
  hasOtherFittingsContainingLead?: Nullable<boolean>;
  contract: Nullable<Contract>;
  connectorMaterial: Nullable<Material>;
  connectorSource: Nullable<string>;
  lifecycleStatus: Nullable<LifeCycleStatus>;
  endDate: Nullable<string>;
  comments: Nullable<string>;
  properties: CustomProperties;
}

export class ServiceLine {
  @Type(() => ServiceLineMaterial)
  serviceLineMaterials: ServiceLineMaterial[];

  @Type(() => Material)
  material: Material;

  // TODO: Serialize rest of the complex object types on SL like contract

  get isActive(): boolean {
    const hasMaterials = this.serviceLineMaterials.length > 0;
    return (!this.endDate || isFuture(new Date(this.endDate))) && hasMaterials;
  }
}

interface LifeCycleStatus {
  id: string;
  code: string;
  description?: Nullable<string>;
  value: string;
  recordId?: Nullable<string>;
}

export type ServiceLineSide = 'Private' | 'Utility';
